module.exports = "//public.zight.com/packs/media/images/icons-slightly-rounded-corners-c825132c352f0defd3dda3e5f40e56c2.svg";